<template>
	<div class="index-box">
		<img src="../../../static/m/index/logo.png" class="logo"/>
		<van-image  fit="cover"
		  :src="indexMain"
		/>
		<div class="notice-box" v-if="isShowNews" @click="showDetail">
			<img src="../../../static/icon7.png" class="notice-icon"/>
			<img :src="parseImg(newsList[0].ico)" class="news-ico"/>
			<div class="news-title" v-html="parseTitle(newsList[0].title)" ref="myDiv"></div>
			<!-- <div class="news-title" ref="myDiv">
				{{newsList[0].title}}
			</div> -->
		</div>
		<van-popup class="detail-box detail-box2" :overlay="false" closeable :get-container="getContainer" v-if="isShowNews" v-model="showDetailPage" >
			<div class="sub-content">
				<!-- <van-image class="imgItem" :src="parseImg(newsList[0].ico)"/> -->
				<van-row justify="center" class="m-title">
					{{newsList[0].title}}
				</van-row>
				<van-row justify="space-around" class="row-bg">
					时间：{{parseTime(newsList[0].create_time)}}&nbsp;&nbsp;
					来源 ：{{newsList[0].source}}&nbsp;&nbsp;
					访问量 ：{{newsList[0].visits}}
				</van-row>
				<van-divider />
				<div  v-html="newsList[0].content"></div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: 'Home',
		data() {
			return {
				indexMain: require("../../../static/m/index/index-main.png"),
				moreSrc:require('../../../static/icon8.png'),
				isShowNews: false,
				baseUrl: 'https://www.kingstronbio.com',
				appid: "sqks",
				api_secret: "abcdefg",
				timestamp: Date.parse(new Date()) / 1000,
				jiami:'',
				newsList:[],
				showDetailPage: false,
			}
		},
		methods:{
			showPageDetail(item,type) { //type : 1  首页详情   2：内容列表进入
			    this.$store.commit("setBgColor", '#fff');
				this.showDetailPage = true;
				// this.newsInfo = item;
				// this.showDetail = true;
				// this.detailType = type;
				this.$store.commit("setSecondPage", true);
			},
			getContainer() {
				return document.querySelector('.m-pageSwiper');
			},
			async getCompany() {
				//可进行解耦   公司新闻 17    科普知识 18    临床病例19    全部 12
				var that = this;
				await axios (
					{
						url: 'https://www.kingstronbio.com/api.php/list/12/num/100',
						method: 'POST',
						params: {
							"appid": this.appid,
							"signature": md5(md5(this.jiami)),
							"timestamp": this.timestamp,
						}
					}
				)
				.then(res => {
					that.listResult = res.data.data;
					that.newsList = that.listResult.filter(item=>item.scode==="17"); //公司新闻
				    that.parseNews(that.newsList[0])
					
					
				}, error => {
					console.log(error)
				})
			
			},
			parseImg(img) {
				return this.baseUrl + img;
			},
			parseNews(item){
				const startDate = new Date();
				const endDate = new Date(item.date.replace(/-/g,'/'));
				// 计算两个日期之间的天数差
				const diff = Math.abs((startDate.getTime() - endDate.getTime()) / (1000 * 60 * 60 * 24));
				this.isShowNews = diff<=3 ? true: false;
			},
			showDetail(){
				this.$store.commit("setIsListening", false);
				this.$store.commit("setBgColor", '#e5e3e1');
				this.showDetailPage = true ;//内容详情
			},
			parseTitle(title){
				return title+ "<img src="+this.moreSrc+" class='moreBtn'/>"
			},
			parseTime(d){
				if(!d) return;
				return d.split(' ')[0]
			}
		},
		mounted() {
			this.jiami = this.appid + this.api_secret + this.timestamp;
			this.getCompany();
			 
		}
	}
</script>

<style lang="less" scoped>
@import url('@/assets/css/index.less');
	@media only screen and (min-aspect-ratio: ~'486/814'){
		.van-image {
			// border: 1px solid green;
		}
	}
	@media only screen and (min-aspect-ratio: ~'552/814'){
		.van-image {
			top: 60% !important;
			transform: translateY(-50%);
			/deep/img{
					transform: scale(0.95) !important;
					transform-origin: center;
			}
		}
	}
	
	.index-box {
		position: relative;
		background-color: #7b0012;
		width: 100%;
		height: 100%;
		.notice-box{
			// .scale(650,90);
			width: 86%;
			position: absolute;
			left: 80/@r;
			bottom: 90/@r;
			display: flex;
			flex-direction: row;
			cursor: pointer;
			.notice-icon{
				.scale(57,60);
			}
			.news-ico{
				margin-left: 10/@r;
				width: 190/@r;
				height: auto;
			}
			.news-title{
				position: relative;
				margin-left: 10/@r;
				font-size: 38/@r;
				line-height: 50/@r;
				height: 150/@r;
				color: #fff;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 3;  // 显示几行
				-webkit-box-orient: vertical;
				overflow: hidden;
			}
			/deep/.moreBtn{
				width: 36/@r;
				height: 36/@r;
				margin-left: 10/@r;
				display: inline-block;
				position: absolute;
				margin-top: 5/@r;
			}
		}
	}
	.detail-box {
		width:100%;
		height:100%;
		display: block;
		background-color: #fff ;
		overflow-x: hidden;
		
		/deep/.van-popup__close-icon {
			font-size: 30px;
			color:#4d4d4d;
		}
		.detail-img {
			margin-bottom: 200/@r;
		}
		.sub-content {
			padding: 140/@r 105/@r 200/@r;
			color: #4d4d4d;
			.title-main {
				.scale(313,173);
				display: block;
				margin-top:66/@r;
			}
			.imgItem{
				margin-top:66/@r;
			}
			.con-moreBtn{
				text-align: right;
			}
			/deep/p {
				margin-top: 30/@r;
				font-size: 45/@r;
			}
			/deep/.van-divider{
				border-color: #4d4d4d;
			}
			/deep/video{
				width: 100%;
				height: auto;
			}
		}
	}
	.detail-box2{
		
		.m-title {
			font-size: 60/@r;
			margin: 30/@r auto;
			font-weight: bold;
			text-align: center;
			cursor: pointer;
		}
		/deep/img {
			display: block;
			float: none;
			width: 100% !important;
			height: auto !important;
			padding: 5px;
		}
		.row-bg{
			font-size: 40/@r;
		}
		.m-avator {
			.scale(250, 129);
		}
		/deep/ul{
			width: 100% !important;
		}
	}
	.logo{
		position: absolute;
		right: 50/@r;
		top: 50/@r;
		width: 350/@r;
	}
	.van-image {
		.pos-center();
		top: 53%;
		.scale(940,1664);
	}
</style>